// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7f8944c3]:export{a:#5a80fb;b:#6b88fc;c:#7b91fc;d:#8899fd;e:#95a2fd;f:#a1abfe;g:#adb4fe;h:#b8bdfe;i:#c3c6ff;j:#cdcfff;k:#d8d9ff;l:#e2e2ff;m:#ececff;n:#f5f5ff;o:#fff}.nav-content--title[data-v-7f8944c3]{color:var(--color-neutral-10);font-size:20px;font-weight:600;line-height:24px;overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
